"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GenericRepo_1 = __importDefault(require("./GenericRepo"));

var OrderRepo =
/** @class */
function (_super) {
  __extends(OrderRepo, _super);

  function OrderRepo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  OrderRepo.prototype.countByRef = function (ref) {
    var qry = {};

    if (Array.isArray(ref)) {
      qry = {
        ref: {
          $in: ref
        }
      };
    } else {
      qry = {
        ref: ref
      };
    }

    return this.coll.count(qry);
  };

  OrderRepo.prototype.findExistingRefs = function (refs) {
    var _this = this;

    return new Promise(function (res, rej) {
      var map = new Map();

      _this.coll.find({
        ref: {
          $in: refs
        }
      }, {
        projection: {
          _id: 1,
          ref: 1
        }
      }).toArray().then(function (items) {
        var e_1, _a;

        try {
          for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var item = items_1_1.value;
            map.set(item.ref.toLowerCase(), item._id);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        res(map);
      }).catch(rej);
    });
  };

  OrderRepo.prototype.getDistinctsLivraisonModes = function () {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.coll.aggregate([{
        $group: {
          _id: null,
          value: {
            $addToSet: "$livraison.modeLabel"
          }
        }
      }]).then(function (r) {
        var modes = [];

        if (r.length > 0) {
          r[0].value.forEach(function (o) {
            modes.push(o);
          });
        }

        res(modes);
      }).catch(rej);
    });
  };

  OrderRepo.prototype.updateState = function (ids, state) {
    var _this = this;

    ids = Array.isArray(ids) ? ids : [ids];
    return this.ensureObjectIds(ids).then(function (ids) {
      return _this.coll.updateMany({
        _id: {
          $in: ids
        }
      }, {
        $set: {
          state: state,
          modified: new Date()
        }
      });
    });
  };

  OrderRepo.prototype.updateCarrier = function (id, carrier) {
    var _this = this;

    return this.ensureObjectId(id).then(function (id) {
      return _this.coll.updateOne({
        _id: id
      }, {
        $set: {
          "internal.carrier": carrier
        }
      });
    });
  };

  OrderRepo.prototype.listOrders = function (archived) {
    if (archived === void 0) {
      archived = false;
    }

    return this.find({
      archive: archived
    }, {
      date: -1
    }, {}, 5000);
  };

  OrderRepo.prototype.archive = function (ids, archive) {
    var _this = this;

    if (archive === void 0) {
      archive = true;
    }

    return this.ensureObjectIds(ids).then(function (ids) {
      return _this.coll.updateMany({
        _id: {
          $in: ids
        }
      }, {
        $set: {
          modified: new Date(),
          archive: archive
        }
      });
    });
  };

  return OrderRepo;
}(GenericRepo_1.default);

exports.default = OrderRepo;